import type { ParseKeys } from "i18next";

import type { IApptType, ICreateAppointmentParams } from "./path";
import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

const getTitle = (type: IApptType): ParseKeys<"common"> => {
  if (type === "no-show") return "pageTitle.noShow";
  if (type === "all") return "pageTitle.appointmentList";
  if (type === "online-visit") return "pageTitle.onlineVisits";
  return "pageTitle.inPersonVisits";
};

export const appointmentRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/appointment/appointmentListPage"),
      loader: async ({ params, request }) => {
        const type = params?.appt_type as IApptType;

        const title: ParseKeys<"common"> = getTitle(type);

        useUIStore.getState().setPage(request, title, [], "index", "main");
        return { type };
      },
    },
    permissions: [
      "doctor",
      "patient",
      "super-admin",
      "staff",
      "admin",
      "local-admin",
    ],
  },
  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/appointment/viewAppointmentPage"),
      loader: async ({ params, request }) => {
        const type = params?.appt_type as IApptType;

        const title: ParseKeys<"common"> = getTitle(type);

        useUIStore.getState().setPage(
          request,
          "pageTitle.viewAppointment",
          [
            {
              title,
              url: path.list.link(type),
            },
          ],
          "view",
        );
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "super-admin",
      "staff",
      "admin",
      "local-admin",
    ],
  },
  {
    route: {
      path: path.create.route,
      lazy: () => import("@pages/panelPages/makeAppointment/makeAppointment"),
      loader: async ({ request, params }) => {
        const { appt_type: apptType } = params as ICreateAppointmentParams;

        const title: ParseKeys<"common"> =
          apptType === "online-visit"
            ? "pageTitle.onlineVisits"
            : "pageTitle.inPersonVisits";

        useUIStore.getState().setPage(
          request,
          "pageTitle.createAppointment",
          [
            {
              title,
              url: path.list.link(apptType),
            },
          ],
          "create",
        );
        return { appt_type: apptType };
      },
    },
    permissions: [
      "staff",
      "patient",
      "admin",
      "doctor",
      "local-admin",
      "super-admin",
    ],
  },
  {
    route: {
      path: path.reschedule.route,
      lazy: () => import("@pages/panelPages/appointment/reschedule"),
      loader: async ({ request, params }) => {
        const type = params?.appt_type as IApptType;

        const title: ParseKeys<"common"> = getTitle(type);

        useUIStore.getState().setPage(
          request,
          "pageTitle.rescheduleAppointment",
          [
            {
              title,
              url: path.list.link(type),
            },
          ],
          "edit",
        );
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "super-admin",
      "staff",
      "admin",
      "local-admin",
    ],
  },
];
